import {HTTP} from '@/services/HttpServices';
import {LoginResult} from '@/interfaces/User';

export function attemptLogin(email: string, password: string): Promise<LoginResult> {
    return HTTP.post('/login', {email, password});
}

export function sendResetPassword(email: string): Promise<void> {
    return HTTP.put('/reset-password/', { email: email });
}

export async function attemptLogout(): Promise<void> {
    await HTTP.post('/logout');
}

export function getUser(userId: number): Promise<any | null> {
    return HTTP.get(`/admin/users/${userId}`);
}

export function getAllUsers(): Promise<any | null> {
    return HTTP.get(`/admin/users/`);
}

export function getAllUsersUnsecured(): Promise<any | null> {
    return HTTP.get(`/admin/users/unsecured`);
}

export function updateUserPassword(userId: number, passwordData: any): Promise<any | null> {
    return HTTP.put(`/admin/users/${userId}/update-password`, passwordData);
}

export function insertUser(user: any): Promise<any> {
    return HTTP.post('/admin/users', user);
}

export function updateUser(user: any): Promise<any> {
    return HTTP.put(`/admin/users/${user.appUserId}`, user);
}

export function authorizePublicWebsite(): Promise<void> {
    return HTTP.get(`/admin/users/public-cookie`, undefined, true);
}
